// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3403LPQnewVhhPoz7QUcE4 {\n  background: rgba(33, 150, 243, 0.27);\n}\n\n._3Ove32koYvwe1zi-xypkJm {\n  margin-top: 0;\n  text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"helpBtn": "_3403LPQnewVhhPoz7QUcE4",
	"header": "_3Ove32koYvwe1zi-xypkJm"
};
module.exports = exports;
